export default __webpack_public_path__ + "static/media/customCloseIcon.0c6a8bc4.svg";